import { Badge } from "@/components/ui/badge";
import type { UserStatus } from "../types";

const variants = {
  ACTIVE: "success" as const,
  INACTIVE: "secondary" as const,
  SUSPENDED: "destructive" as const,
};

const labels: Record<UserStatus, string> = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SUSPENDED: "Suspended",
};

export function StatusBadge({ status }: { status: UserStatus }) {
  return <Badge variant={variants[status]}>{labels[status]}</Badge>;
}
